import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  const [formData, setFormData] = useState({
    email: '',
    comunicacionComercial: true
  });

  const [status, setStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(t('footer.sending'));

    try {
      const response = await fetch('https://faraday.land/webhook/form-contacto', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setStatus(t('footer.successMessage'));
        setFormData({
          email: '',
          comunicacionComercial: true
        });
      } else {
        setStatus(t('footer.errorMessage'));
      }
    } catch (error) {
      setStatus(t('footer.connectionError'));
    }
  };

  const copyrightText = t('footer.copyright').replace('{year}', currentYear);

  const links = [
    { href: '/legal-notice', label: t('footer.legalNotice') },
    { href: '/privacy-policy', label: t('footer.privacyPolicy') },
    { href: '/terms-of-service', label: t('footer.termsOfService') },
    { href: '/cookie-policy', label: t('footer.cookies') },
    { href: '/eula', label: t('footer.eula') },
  ];

  return (
    <footer className="border-t border-white/10 bg-black text-[#fffefa]">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-start">
          <div className="lg:col-span-3">
            <div className="flex items-center gap-3">
              <img src="/farm-logo.png" alt="FARM" className="h-10 w-10 rounded-md" />
              <div>
                <div className="text-lg font-medium text-white">FARM</div>
                <div className="text-xs uppercase text-[#8d8d95]">by Farmway</div>
              </div>
            </div>
            <div className="mt-7 space-y-2">
              <h4 className="text-sm font-medium text-white">{t('footer.support')}</h4>
              <p className="text-xs text-[#8d8d95]">{t('footer.email')}</p>
              <a href="mailto:support@farmway.dev" className="text-sm text-[#d7d6de] transition-colors duration-200 hover:text-white">
                support@farmway.dev
              </a>
            </div>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-2xl font-normal text-white">{t('footer.newsletterTitle')}</h4>
            <p className="mt-3 max-w-md leading-7 text-[#b7b5c2]">
              {t('footer.newsletterSubtitle')}
            </p>
          </div>

          <div className="lg:col-span-5">
            <form onSubmit={handleSubmit} className="flex flex-col gap-3 sm:flex-row">
              <input
                type="email"
                name="email"
                placeholder={t('footer.emailPlaceholder')}
                value={formData.email}
                onChange={handleChange}
                className="min-h-[48px] flex-1 rounded-md border border-white/10 bg-white/[0.05] px-4 text-white placeholder-[#8d8d95] outline-none transition-colors duration-200 focus:border-[#0a84ae]"
                required
              />
              <button
                type="submit"
                className="min-h-[48px] rounded-md bg-white px-6 text-sm font-medium text-black shadow-[inset_0_-12px_20px_rgba(255,255,255,0.45),0_4px_14px_rgba(255,255,255,0.14)] transition-transform duration-200 hover:-translate-y-0.5"
              >
                {t('footer.subscribe')}
              </button>
            </form>
            {status && (
              <p className="mt-3 text-sm text-[#d7d6de]">
                {status}
              </p>
            )}
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-8">
          <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
            <div className="text-sm text-[#8d8d95]">
              {copyrightText}
            </div>
            <div className="flex flex-wrap gap-x-6 gap-y-3 text-sm text-[#8d8d95]">
              {links.map((link) => (
                <a key={link.href} href={link.href} className="transition-colors duration-200 hover:text-white">
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
